import GNBContainer from '@components/common/GNB/containers/GNBContainer';
import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoginNavigationContainer from './containers/LoginNavigationContainer';
import MainNavigationContainer from './containers/MainNavigationContainer';

type Props = {
  root: 'login' | 'main';
};

const RootNavigation = ({ root }: Props) => {
  return (
    <BrowserRouter>
      {root === 'login' && <LoginNavigationContainer />}
      {root === 'main' && <MainNavigationContainer />}
    </BrowserRouter>
  );
};

export default RootNavigation;
